import {NavbarTop} from "../ui_components/navbar_top";
import { useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import Editor from '@monaco-editor/react';
import classNames from 'classnames';
import { errorMsg, homeUrl, success } from "../utils/common_utils";
import QuestionCodeSubmission from "./question_code_submission";
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import { QuestionNotesLink } from "./question_notes";
import { getCurrrentLanguage, getUIState, isPremiumUser } from "../login/auth_utils";
import LoginModal from "../login/email_login_modal";
import { BuyPremium, VisitPremiumSection } from "../premium/premium_discounts";
import { LeftIcon } from "../ui_components/common_icons";
import { QuestionSolutions } from "./question_solutions";
import { BRR } from "../ui_components/common_ui_components";
import { CompanyTagListToggle, TagsListUI } from "./tags_list_ui";
import { extractQuestionId } from "./question_utils";


function QuestionTopTabButton({ active, onClick, children, activeColor = "blue" }) {
  const activeClass =
    activeColor === "green"
      ? "border-emerald-700 bg-emerald-700 text-white"
      : "border-blue-700 bg-blue-700 text-white";

  return (
    <button
      type="button"
      className={`
        inline-flex min-w-[145px] items-center justify-center rounded-full
        border px-4 py-2 text-sm font-semibold transition-colors duration-200
        focus:outline-none
        ${
          active
            ? activeClass
            : "border-slate-300 bg-white text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        }
      `}
      onClick={onClick}
    >
      {children}
    </button>
  );
}


function VerticalResizeDivider({ onResizeStart }) {
  return (
    <div
      className="
        group hidden md:flex md:w-5 md:flex-none
        cursor-col-resize items-stretch justify-center
      "
      onMouseDown={onResizeStart}
      onTouchStart={onResizeStart}
      role="separator"
      aria-orientation="vertical"
      title="Drag to resize"
    >
      <div
        className="
          relative my-4 w-px rounded-full bg-slate-200
          transition-all duration-200 group-hover:w-1 group-hover:bg-blue-300
        "
      >
        <div
          className="
            absolute left-1/2 top-1/2 flex h-14 w-4
            -translate-x-1/2 -translate-y-1/2 items-center justify-center
            rounded-full bg-white shadow-sm
            transition-all duration-200 group-hover:shadow-md
          "
        >
          <div className="h-8 w-1 rounded-full bg-slate-300 group-hover:bg-blue-400" />
        </div>
      </div>
    </div>
  );
}



const QuestionDescription = () => {
  //const [code, setCode] = useState('');
  const [question, setQuestion] = useState({});
  const [questionDescription, setQuestionDescription] = useState('');
  const [questionHeading, setQuestionHeading] = useState('');
  //const [input, setInput] = useState('');
  //const [output, setOutput] = useState('');
  // const [loading, setLoading] = useState(false);
  //const[language, setLanguage] = useState(getCurrrentLanguage())
  const[error, setError] = useState('')
  const[showEditorial, setShowEditorial]=useState(false)

  const { questionId } = useParams();
  const [extractedQuestionId, setExtractedQuestionId] = useState(0)

  const layoutRef = useRef(null);
  const [leftPanelWidth, setLeftPanelWidth] = useState(40);

  const startResize = (event) => {
    event.preventDefault();

    const moveHandler = (moveEvent) => {
      if (!layoutRef.current) return;

      const clientX =
        moveEvent.touches && moveEvent.touches.length > 0
          ? moveEvent.touches[0].clientX
          : moveEvent.clientX;

      const rect = layoutRef.current.getBoundingClientRect();
      const nextWidth = ((clientX - rect.left) / rect.width) * 100;

      // Keep both panels usable.
      const safeWidth = Math.max(28, Math.min(62, nextWidth));
      setLeftPanelWidth(safeWidth);
    };

    const stopHandler = () => {
      document.removeEventListener("mousemove", moveHandler);
      document.removeEventListener("mouseup", stopHandler);
      document.removeEventListener("touchmove", moveHandler);
      document.removeEventListener("touchend", stopHandler);
    };

    document.addEventListener("mousemove", moveHandler);
    document.addEventListener("mouseup", stopHandler);
    document.addEventListener("touchmove", moveHandler);
    document.addEventListener("touchend", stopHandler);
  };
  
 /* const handleSubmit = async () => {
    setLoading(true);
    // Make API request to run code and get output
    setLoading(false);
  };
*/
useEffect(() => {
  let exId = extractQuestionId(questionId, "0")
  setExtractedQuestionId(exId)
  console.log("question id "+questionId+", extracted question id "+exId)
  
  console.log("fetching the question description");
  fetch(homeUrl()+"questionsApi/question/"+exId, {
    method: "GET"
  })
    .then((response) => response.json())
    .then((data) => {
      if(success(data.status)){
        console.log(" question data fetched "+JSON.stringify(data.question))
        setQuestionDescription(data.description)
        setQuestionHeading(""+data.question.questionId+". "+data.question.heading)
        // 
        setQuestion(data.question)
        document.title = ""+data.question.questionId+". "+data.question.heading
      }
      else{
        console.log("error data "+JSON.stringify(data))
        setError(data.message || "Error in fetching questions, please try again")
      }
       // console.log("response received")
       // console.log(data);
    })
    .catch((error) => {
      console.log("error occured in fetching all questions "+JSON.stringify(error));
      setError(errorMsg())
    });  
}, []); // empty bracket means there are no dependencies which will make useEffect re run

  return (
  <div className="min-h-screen bg-white">
    <NavbarTop />

   <div
    ref={layoutRef}
    className="
      flex w-screen flex-col pt-20
      md:h-screen md:flex-row md:overflow-hidden
    "
   >
  
    <div
      className="
        flex w-full flex-col overflow-y-auto bg-white
        md:h-[calc(100vh-5rem)] md:min-w-[320px]
      "
      style={{ flexBasis: `${leftPanelWidth}%` }}
    >
    
    { //.... problem statement and editorial button panel div Starts .....
    <div
      className="
        sticky top-0 z-20 bg-white/95 px-4 pb-3 pt-3 backdrop-blur
      "
    >
      <div
        className="
          flex flex-col gap-3
          sm:flex-row sm:items-center sm:justify-between
        "
      >
        <div className="flex w-full gap-3 overflow-x-auto sm:w-auto">
          <QuestionTopTabButton
            active={!showEditorial}
            activeColor="blue"
            onClick={() => setShowEditorial(false)}
          >
            Problem Statement
          </QuestionTopTabButton>

          <QuestionTopTabButton
            active={showEditorial}
            activeColor="green"
            onClick={() => setShowEditorial(true)}
          >
            Editorial (Solutions)
          </QuestionTopTabButton>
        </div>

        <div className="hidden text-xs font-medium text-slate-400 sm:block">
          Drag divider to resize
        </div>
      </div>
    </div>
    //.... problem statement and editorial button panel div ends .....
}
     { showEditorial && question && question.questionId>0 &&
      <div className="px-5 py-4">
        <QuestionSolutions question={question} />
      </div>
     }

     { // ..... display problem statement section starts  .....
     !showEditorial && 
     <div className="overflow-x-auto px-5 pb-10 pt-3">
     
     { error &&
      <div
        className="
          rounded-2xl bg-red-50 px-4 py-5 text-center
          text-lg font-semibold italic text-red-600
        "
      >
        {error} &nbsp; ...
      </div>
      }

      <div
        className="
          text-2xl font-extrabold leading-snug tracking-tight
          text-slate-900 md:text-3xl
        "
        dangerouslySetInnerHTML={{ __html: questionHeading }}
      >
      </div>

      {questionDescription.length==0 && 
        <div className="flex min-h-[180px] items-center justify-center">
          <IndefiniteProgressBar />
        </div>
      }

      {
        question && question.companies && question.companies.length>0 &&
        <div className="mt-5">
          <CompanyTagListToggle companies= {question.companies} />
        </div>
      }

      { false && <div className="mx-4 font-mono text-gray-600">
        <strong className="text-black"> This question has been asked in </strong>
        {question.companies.map(company => company.name).join(", ")}
      </div>
      }
      
      <div
        className="
          prose prose-slate mt-8 max-w-none text-black
          prose-p:leading-8 prose-li:leading-8
          prose-strong:text-slate-900
        "
        dangerouslySetInnerHTML={{ __html: questionDescription }}
      >
      </div>

      { /*
         false && question && question.thumbnailUrl &&
          <div className='flex flex-row  
          text-center justify-center items-center'>
            <img className='w-1/2'
                src={question.thumbnailUrl}
            />
          </div>
          */
        }
      <BRR /> <BRR /> <br /> <br />
     </div>
     } 
    </div> 

    <VerticalResizeDivider onResizeStart={startResize} />
     
     {false && <div className="flex-item w-0.5 h-screen m-2 bg-gray-600"></div>
     }

    <div className="block text-center my-4 mx-4 rounded-2xl bg-blue-50 text-blue-700 p-4 font-bold shadow-sm md:hidden">
      Please use Laptop/Desktop or any other large screen to add/edit code.
    </div>

    {/* the editor will be visible only on laptop/desktop or large screen */}
    <div
      className="
        hidden bg-white md:block md:h-[calc(100vh-5rem)]
        md:min-w-[420px] md:overflow-y-auto md:pr-4
      "
      style={{ flexBasis: `${100 - leftPanelWidth}%` }}
    >
    { question && question.heading &&
      <QuestionCodeSubmission question={question} />
    }
    </div>
    <br /> <br />
    </div>
    </div>
  );
  
}

 export default QuestionDescription;

 {/*
 <div className="flex flex-col h-screen">
      <div className="flex-item h-3/4"> 
      <h2 className="text-xl font-bold mb-2">{language} Code Editor:</h2>
          <Editor
            height="500px"
            defaultLanguage={language}
            defaultValue="// Enter your code here"
            value={code}
            onChange={setCode}
          />
       </div>
    <div className="flex-item w-screen h-0.5 m-4 bg-gray-600"></div>
    <div className="flex-item h-1/4"> 
      <h2 className="text-xl font-bold mb-2">Command Line:</h2>
          
      <button
        className={classNames('bg-blue-500 text-white px-4 py-2 rounded-lg', {
          'opacity-50 cursor-not-allowed': loading,
        })}
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? 'Running...' : 'Run'}
      </button>
      
    <div className="mt-4 mb-16">
      <h2 className="text-xl font-bold mb-2">Output:</h2>
      <div className="bg-gray-100 p-4 rounded-lg">
        <pre className="text-gray-900">{output}</pre>
      </div>
    </div>
       
       </div>
      </div> 
*/}